import { render, staticRenderFns } from "./Heritage.vue?vue&type=template&id=63e38895&"
import script from "./Heritage.vue?vue&type=script&lang=js&"
export * from "./Heritage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports